module.exports = __webpack_public_path__ + "static/media/corporate-services-img74.e40012a4.jpg";